// components/Toast/Toast.jsx

import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Toast.scss';
import Icon from "../Icon/Icon";


const Toast = props => {

    // 파라미터 셋팅
    const {
        type,
        message,
        opt = null
    } = props;


    // 커스텀 닫기 버튼
    const CustomCloseButton = ({ closeToast }) => (
        <button
            onClick={closeToast}
            style={{marginRight: '13px', display: 'flex', alignItems: 'center',}}>
            <Icon id="close_02" width="16" height="17"/>
        </button>
    );

    //option: info, success, warning, error
    const CustomIcon = () => (
        <div style={{marginLeft: '13px', display: 'flex', alignItems: 'center', justifyContent:'center'}}>
            <Icon id={"toast_"+type} width="16" height="17"/>
        </div>
    );

    const option = {
        position: "top-center",
        autoClose: 2000,
        type:type,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "light",
        closeButton: <CustomCloseButton/>,
        icon: <CustomIcon/>,
        style: {
            backgroundColor: {"info":"#333333", "success":"#02C408", "warning":"#FFBB00", "error":"#FF0010"}[type],
            color: "#FFFFFF"
        },
        ...opt,
    }

    const ToastComponent = () => (
        <div className="toastMsgBox">
            {message}
        </div>
    );

    toast(<ToastComponent />,option);
};

export default Toast;